import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import './assets/css/style.css';

import IconFooter from "./assets/img/common/logo_footer.svg";

import HeaderMenu, { TOPMENU } from './components/HeaderMenu';
import PageTopButton from './components/PageTopButton';

import Contact from './routes/contact/Contact';
import ContactConfirm from './routes/contact/ContactConfirm';
import ContactComplete from './routes/contact/ContactComplete';

function App() {

  // 常にページトップから表示する細工
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname])

  return (

    <>
    {/** header部 */}
    <header id="header" className="l-header" aria-label="メインヘッダー">
    <div className="l-header__inner">
        <div className="l-header__logo"><a href="/hdocs/bxsselect.html">予算書・決算書データベース</a></div>
        {/** トップメニュー */}
        <Routes>
            <Route path="/*" element={<HeaderMenu />} />
        </Routes>
    </div>
    </header>

    {/** main部 */}
    <Routes>
        <Route path="/*" element={<Contact />} />
        <Route path="/confirm" element={<ContactConfirm />} />
        <Route path="/complete" element={<ContactComplete />} />
    </Routes>

    {/** トップへ戻るボタン */}
    <PageTopButton />

    {/** フッター部 */}
    <footer id="footer" className="l-footer" aria-label="メインフッター">
      <div className="l-footer__inner">
          <div className="l-footer__logo-top">予算書・決算書データベース</div>
          <nav className="l-footer__menu" aria-label="フッターメニュー">
            <ul>
              <li><a href="/help/">ヘルプ</a></li>
              <li><a href="/terms/">利用規約</a></li>
              <li><a href="/privacy/">プライバシーポリシー</a></li>
              <li><a href="/accessibility/">ウェブアクセシビリティ</a></li>
              <li><a href="/contact/">お問合せ</a></li>
            </ul>
          </nav>
          <div className="l-footer__logo-bottom"><a href="https://www.mof.go.jp/" target="_blank"><img src={IconFooter} alt="財務省" /></a></div>
          <p className="l-footer__copylight" lang="en">Copyright &copy; Ministry of Finance Japan. All Rights Reserved.</p>
      </div>
    </footer>

    </>
  );
}

export default App;
